import { useTRPC } from "../../../../trpc/client";
import { useMerchant } from "../../../../hooks/useMerchant";
import { useQuery } from "@tanstack/react-query";

export function useFetchWithdrawal(withdrawalId: string | null) {
  const trpc = useTRPC();
  const { merchant } = useMerchant();

  const { data, isLoading, refetch } = useQuery(
    trpc.withdrawals.get.queryOptions(
      { rentalsMerchantId: merchant?.id ?? "", id: withdrawalId ?? "" },
      {
        enabled: !!merchant?.id && !!withdrawalId,
      }
    )
  );

  return {
    withdrawal: data,
    isLoadingWithdrawal: isLoading,
    refetchWithdrawal: refetch,
  };
}
